import Tooltip from 'rc-tooltip';

import { SectionDto } from '~modules/section/model';
import { CheckBox, Svg } from '~shared/ui';

type PropsType = {
	section: SectionDto;
	onEdit: (id: number) => void;
	onChangeAllAllowed: (id: number, value: boolean) => void;
};

export function SectionItem({ section, onEdit, onChangeAllAllowed }: PropsType) {
	const { id, title, is_all_allowed } = section;

	const handleEdit = () => {
		if (id) onEdit(id);
	};

	const handleChangeAllAllowed = () => {
		if (id) onChangeAllAllowed(id, !is_all_allowed);
	};

	return (
		<tr>
			<td>{title}</td>
			<td>
				<CheckBox checked={is_all_allowed} onChange={handleChangeAllAllowed} />
			</td>
			<td width={1}>
				<div className="buttons">
					<Tooltip placement="top" overlay="Редактировать">
						<button className="btn chart-btn" onClick={handleEdit}>
							<Svg name="edit" />
						</button>
					</Tooltip>
				</div>
			</td>
		</tr>
	);
}
